<template>
    <div id="bene-d2d-container">
        <f7-list form class="form-group" v-if="showFormSet.doorToDoor || (showFormSet.bankTransfer && showFormSet.provinceDetails)">
            <f7-list-input
                input-id     ="locatingNote"
                name         ="locatingNote"
                type         ="text"
                v-if         ="showFormSet.doorToDoor"
                :label       ="$t('beneficiary-locating-note-optional')"
                :placeholder ="$t('beneficiary-locating-note-optional')"
                :value       ="locatingNote"
                @change      ="setLocatingNote($event.target.value); validateInput($event.target); setInput($event.target);"

                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="landmark"
                name         ="landmark"
                type         ="text"
                
                :label       ="landmarkLabel"
                :placeholder ="landmarkLabel"
                :value       ="landmark"
                @change      ="setLandmark($event.target.value); validateInput($event.target); setInput($event.target);"

                maxlength    ="100"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'locatingNote',
                'landmark',
                'landmarkLabel'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setLocatingNote',
                'setLandmark'
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>